import { ISearchResultSectionWrapper } from '../interface';
import { NO_RESULT_ID } from '../constants';
import { replacePlaceholders } from '@vfde-sails/utils';

/**
 * get no results item
 */
export const getNoResults = (searchString: string): ISearchResultSectionWrapper => {
    const { errorImageUrl = '', textResources: { noResultText = '' } } = window.globalPageOptions?.search || { textResources: {} };

    return {
        sections: [
            {
                id: NO_RESULT_ID,
                items: [
                    {
                        image: errorImageUrl,
                        text: replacePlaceholders(noResultText, {
                            searchString,
                        }),
                        link: '',
                    },
                ],
            },
        ],
        resultCount: 1,
    };
};
